module.exports = __webpack_public_path__ + "static/img/brand_story_main_en.17ec8ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brandStory/brand_story_main_en.png
// module id = 8hJO
// module chunks = 0